export const fnBodyToSend = (values, product, productId, uuid) => {
  const dataCard = {
    payment_type: values.payment_type,
    card_info: {
      fullname: `${values.possible_customer_firstname} ${values.possible_customer_lastname}`,
      pan: values.card_number,
      cvv: values.card_cvv,
      expiration_date: values.card_expiration_date,
      installments: Number(values.installments),
    },
    customer_info: {
      doc_type: values.customer_document_type,
      doc_number: values.customer_document_number,
      first_name: values.customer_firstname,
      last_name: values.customer_lastname,
      email: values.customer_email,
      phone_number: values.customer_number_phone,
    },
    venue: values.customer_venue,
    city: values.customer_city,
    uuid,
    start_date: values.execute_at,
    product_id: product?.is_promotional ? null : productId,
    promotion_id: product?.is_promotional ? productId : null,
    subtotal: product.subtotal,
    discount: product.discount,
    total: product.total,
    terms_of_use: values.terms_of_use,
    user_agent: window.navigator.userAgent,
  };

  const dataPSE = {
    payment_type: values.payment_type,
    account_type: values.account_type,
    account_number: values.account_number,
    bank: values.bank,
    customer_info: {
      doc_type: values.customer_document_type,
      doc_number: values.customer_document_number,
      first_name: values.customer_firstname,
      last_name: values.customer_lastname,
      email: values.customer_email,
      phone_number: values.customer_number_phone,
    },
    venue: values.customer_venue,
    city: values.customer_city,
    uuid,
    start_date: values.execute_at,
    product_id: product?.is_promotional ? null : productId,
    promotion_id: product?.is_promotional ? productId : null,
    subtotal: product.subtotal,
    discount: product.discount,
    total: product.total,
    terms_of_use: values.terms_of_use,
    user_agent: window.navigator.userAgent,
  };

  return values.payment_type === "card" ? dataCard : dataPSE;
};
